import { LegacyCrmDeeplinkConfig } from 'models/LegacyCrmDeeplink';
import { ContextState } from 'saga/context';

/**
 * Entity types for determining which entity should be purged from the application session context.
 */
export enum ClearContextEntityType {
  CUSTOMER = 'Customer',
  EXTERNAL_USER = 'ExternalUser',
  ORDER = 'Order',
  CUSTOMER_REQUEST = 'CustomerRequest',
  INTERACTION = 'Interaction',
  TARIFF_SPACE = 'TariffSpace',
  ASSET = 'Asset',
  CUSTOMER_ACCOUNT = 'CustomerAccount',
  PARTNER_CONTRACT = 'partnerContract',
}

/**
 * Defines inputs for clearContext.request Saga action.
 */
export interface ClearContextRequestActionInputs {
  skipSharedObjectsSession?: boolean;
  clearContextEntity?: ClearContextEntityType | undefined;
  clearRelatedEntities?: boolean;
  deeplinkAfterClearContext?: LegacyCrmDeeplinkConfig;
}

/**
 * Defines inputs for clearContext.success Saga action.
 */
export interface ClearContextSuccessActionInputs {
  sessionContext: ContextState;
  clearContextEntity?: ClearContextEntityType;
  clearRelatedEntities: boolean;
}
